import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlane,
  faWallet,
  faComments,
  faShieldHalved,
} from "@fortawesome/free-solid-svg-icons";
import { config } from "../config";

function Benefits() {
  const benefits = [
    {
      icon: faPlane,
      title: "Effortless Travel Planning",
      description:
        "Simplify your journey with an intuitive platform that makes booking trips a breeze.",
    },
    {
      icon: faWallet,
      title: "Exclusive Deals, Unmatched Value",
      description:
        "Unlock access to competitive pricing and special offers you won't find anywhere else.",
    },
    {
      icon: faShieldHalved,
      title: "Travel Your Way",
      description:
        "Customize your trip with flexible options like direct flights and curated stays tailored to your needs.",
    },
    {
      icon: faComments,
      title: "Trusted for Every Adventure",
      description:
        "Rely on secure bookings and exceptional customer support to make your travels worry-free.",
    },
  ];

  return (
    <div className="container mx-auto px-4 py-12 md:py-16">
      <h2 className="text-2xl md:text-3xl font-bold text-center mb-8 md:mb-12">
        Why Book With Us
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
        {benefits.map((benefit, index) => (
          <div
            key={index}
            className="bg-gray-50 rounded-lg p-6 md:p-8 text-center shadow-sm hover:shadow-md transition-shadow"
          >
            <div
              className={`w-12 h-12 md:w-16 md:h-16 bg-${config.primaryColor} bg-opacity-10 rounded-full flex items-center justify-center mx-auto mb-4 md:mb-6`}
            >
              <FontAwesomeIcon
                icon={benefit.icon}
                className={`text-${config.primaryColor} text-xl md:text-2xl`}
              />
            </div>
            <h3 className="text-lg md:text-xl font-bold mb-2 md:mb-3">
              {benefit.title}
            </h3>
            <p className="text-sm md:text-base text-gray-600">
              {benefit.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Benefits;
